import { render, staticRenderFns } from "./ExpertProtocols.vue?vue&type=template&id=20e05420&scoped=true"
import script from "./ExpertProtocols.vue?vue&type=script&lang=js"
export * from "./ExpertProtocols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e05420",
  null
  
)

export default component.exports